import { Stack, Typography } from '@cmg/design-system';

type HighlightLabelValueProps = Readonly<{
  label: string;
  value: string;
}>;

export function HighlightLabelValue({ label, value }: HighlightLabelValueProps) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} aria-label={`Highlight ${label}`}>
      <Typography variant="overline">{label}</Typography>{' '}
      <Typography variant="highlight2">{value}</Typography>
    </Stack>
  );
}
